/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateFunnelSessionRequest,
  CreateFunnelSessionResponse,
  FunnelLeadResponse,
  HTTPValidationError,
  UpdateFunnelLeadRequest
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Mint an anonymous funnel session.

Returns the raw session token; the client must persist it and send it on
subsequent funnel requests via the X-Funnel-Session header. The raw token
never appears in the database — only its HMAC-SHA256 hash is stored.
 * @summary Create Funnel Session
 */
export const createFunnelSessionV1FunnelSessionsPost = (
    createFunnelSessionRequest: CreateFunnelSessionRequest,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<CreateFunnelSessionResponse>(
      {url: `/v1/funnel-sessions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createFunnelSessionRequest, signal
    },
      );
    }
  


export const getCreateFunnelSessionV1FunnelSessionsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFunnelSessionV1FunnelSessionsPost>>, TError,{data: CreateFunnelSessionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFunnelSessionV1FunnelSessionsPost>>, TError,{data: CreateFunnelSessionRequest}, TContext> => {

const mutationKey = ['createFunnelSessionV1FunnelSessionsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFunnelSessionV1FunnelSessionsPost>>, {data: CreateFunnelSessionRequest}> = (props) => {
          const {data} = props ?? {};

          return  createFunnelSessionV1FunnelSessionsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFunnelSessionV1FunnelSessionsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createFunnelSessionV1FunnelSessionsPost>>>
    export type CreateFunnelSessionV1FunnelSessionsPostMutationBody = CreateFunnelSessionRequest
    export type CreateFunnelSessionV1FunnelSessionsPostMutationError = HTTPValidationError

    /**
 * @summary Create Funnel Session
 */
export const useCreateFunnelSessionV1FunnelSessionsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFunnelSessionV1FunnelSessionsPost>>, TError,{data: CreateFunnelSessionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFunnelSessionV1FunnelSessionsPost>>,
        TError,
        {data: CreateFunnelSessionRequest},
        TContext
      > => {

      const mutationOptions = getCreateFunnelSessionV1FunnelSessionsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get the current lead data for the resolved funnel session.
 * @summary Get My Funnel Lead
 */
export const getMyFunnelLeadV1FunnelSessionsMeLeadGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<FunnelLeadResponse>(
      {url: `/v1/funnel-sessions/me/lead`, method: 'GET', signal
    },
      );
    }
  



export const getGetMyFunnelLeadV1FunnelSessionsMeLeadGetQueryKey = () => {
    return [
    `/v1/funnel-sessions/me/lead`
    ] as const;
    }

    
export const getGetMyFunnelLeadV1FunnelSessionsMeLeadGetQueryOptions = <TData = Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyFunnelLeadV1FunnelSessionsMeLeadGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>> = ({ signal }) => getMyFunnelLeadV1FunnelSessionsMeLeadGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyFunnelLeadV1FunnelSessionsMeLeadGetQueryResult = NonNullable<Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>>
export type GetMyFunnelLeadV1FunnelSessionsMeLeadGetQueryError = HTTPValidationError


export function useGetMyFunnelLeadV1FunnelSessionsMeLeadGet<TData = Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>,
          TError,
          Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyFunnelLeadV1FunnelSessionsMeLeadGet<TData = Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>,
          TError,
          Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyFunnelLeadV1FunnelSessionsMeLeadGet<TData = Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Funnel Lead
 */

export function useGetMyFunnelLeadV1FunnelSessionsMeLeadGet<TData = Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyFunnelLeadV1FunnelSessionsMeLeadGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyFunnelLeadV1FunnelSessionsMeLeadGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Partially update the lead for the resolved funnel session.

Only fields explicitly present in the request body are written.
 * @summary Update My Funnel Lead
 */
export const updateMyFunnelLeadV1FunnelSessionsMeLeadPatch = (
    updateFunnelLeadRequest: UpdateFunnelLeadRequest,
 ) => {
      
      
      return customCatchBackendFetcher<FunnelLeadResponse>(
      {url: `/v1/funnel-sessions/me/lead`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateFunnelLeadRequest
    },
      );
    }
  


export const getUpdateMyFunnelLeadV1FunnelSessionsMeLeadPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyFunnelLeadV1FunnelSessionsMeLeadPatch>>, TError,{data: UpdateFunnelLeadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateMyFunnelLeadV1FunnelSessionsMeLeadPatch>>, TError,{data: UpdateFunnelLeadRequest}, TContext> => {

const mutationKey = ['updateMyFunnelLeadV1FunnelSessionsMeLeadPatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMyFunnelLeadV1FunnelSessionsMeLeadPatch>>, {data: UpdateFunnelLeadRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateMyFunnelLeadV1FunnelSessionsMeLeadPatch(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMyFunnelLeadV1FunnelSessionsMeLeadPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyFunnelLeadV1FunnelSessionsMeLeadPatch>>>
    export type UpdateMyFunnelLeadV1FunnelSessionsMeLeadPatchMutationBody = UpdateFunnelLeadRequest
    export type UpdateMyFunnelLeadV1FunnelSessionsMeLeadPatchMutationError = HTTPValidationError

    /**
 * @summary Update My Funnel Lead
 */
export const useUpdateMyFunnelLeadV1FunnelSessionsMeLeadPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyFunnelLeadV1FunnelSessionsMeLeadPatch>>, TError,{data: UpdateFunnelLeadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMyFunnelLeadV1FunnelSessionsMeLeadPatch>>,
        TError,
        {data: UpdateFunnelLeadRequest},
        TContext
      > => {

      const mutationOptions = getUpdateMyFunnelLeadV1FunnelSessionsMeLeadPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    